import { Configuration, FlowsApi, type ConfigurationParameters } from '@teemill/flows';
import type { App } from 'vue';

export let flowsClient: FlowsApi;

export const flows = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
    },
  ) {
    flowsClient = new FlowsApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
  },
};
